import { render, staticRenderFns } from "./package-input-fields.vue?vue&type=template&id=8370943a&"
import script from "./package-input-fields.vue?vue&type=script&lang=js&"
export * from "./package-input-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports